import { render } from "./BoxTextarea.vue?vue&type=template&id=8ac0efea&scoped=true"
import script from "./BoxTextarea.vue?vue&type=script&lang=js"
export * from "./BoxTextarea.vue?vue&type=script&lang=js"

import "./BoxTextarea.vue?vue&type=style&index=0&id=8ac0efea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac0efea"]])

export default __exports__